var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 39.688,
    x2: 54.625,
    y1: 47.191,
    y2: 47.191
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "    M54.625,47.191c4.619,0,8.36-3.34,8.36-7.465c0-3.725-3.06-6.817-7.059-7.374l0,0c0-6.518-5.728-12.552-12.073-12.552    c-0.203,0,0.2-0.011,0,0c-3.36,0.182-6.339,1.843-8.327,4.362",
    fill: "none",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M43.854,19.801c-0.756-7.943-7.813-14.17-16.406-14.17c-9.098,0-16.473,6.978-16.473,15.587c0,0.834,0.07,1.654,0.204,2.452l0,0    c-5.72,0.675-10.164,5.668-10.164,11.724c0,6.512,5.144,11.797,11.49,11.797h2.772",
    fill: "none",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "   14.634,58.369 27.541,36.016 40.446,58.369  ",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 27.541,
    x2: 27.541,
    y1: 43.355,
    y2: 50.102
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 27.541,
    x2: 27.541,
    y1: 53.785,
    y2: 54.838
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudError);
export default __webpack_public_path__ + "static/media/cloud-error.3d744971.svg";
export { ForwardRef as ReactComponent };